import React from "react";
import { Container, Typography, Box, Paper, Divider, Link } from "@mui/material";

export default function Impressum() {
    return (
        <Box sx={{ minHeight: "100vh", bgcolor: (t) => t.palette.grey[100], py: 6 }}>
            <Container maxWidth="md">
                <Paper elevation={3} sx={{ p: { xs: 3, md: 4 }, borderRadius: 2 }}>
                    <Typography variant="h4" sx={{ mb: 2, color: "primary.main" }}>
                        Impressum
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        Angaben gemäß § 5 TMG
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        <b>Gaststätte „Zum Alten Rathaus“</b><br />
                        <b>Inhaberin:</b> Mona Hartmann<br />
                        Wilhelmstr. 161<br />
                        42489 Wülfrath
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        <b>Telefon:</b> 02058 – 1 79 86 87<br />
                        <b>E-Mail:</b>{" "}
                        <Link href="mailto:ZumAltenRathaus@gmx.de" underline="hover">
                            ZumAltenRathaus@gmx.de
                        </Link>
                        <br />
                        <b>Internet:</b>{" "}
                        <Link href="https://www.restaurant-wuelfrath.de" target="_blank" rel="noopener noreferrer" underline="hover">
                            www.restaurant-wuelfrath.de
                        </Link>
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        <b>Steuernummer:</b> 139/5910/3372
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                        Haftungsausschluss
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        <b>Haftung für Inhalte</b><br />
                        Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
                        Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach
                        den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
                        jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
                        oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen
                        zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
                        hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
                        konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
                        wir diese Inhalte umgehend entfernen.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        <b>Haftung für Links</b><br />
                        Diese Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
                        Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
                        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
                        zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt
                        der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
                        konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden
                        wir derartige Links umgehend entfernen.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        <b>Urheberrecht</b><br />
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht.
                        Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                        bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
                        nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit Inhalte auf dieser Seite nicht vom Betreiber
                        erstellt wurden, werden die Urheberrechte Dritter beachtet und entsprechende Inhalte gekennzeichnet.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        <b>Hinweis zu KI-generierten Inhalten</b><br />
                        Inhalte, die mit Unterstützung von KI erstellt wurden, können fehlerhaft sein. Wir bemühen uns um sorgfältige Prüfung
                        und Aktualisierung.
                    </Typography>

                    <Typography sx={{ mt: 3 }} color="text.secondary" variant="body2">
                        Stand: {new Date().toLocaleDateString("de-DE")}
                    </Typography>
                </Paper>
            </Container>
        </Box>
    );
}
